import policiesFormStore from '@/modules/policies/policies-form-store';

export default {
  namespaced: true,

  modules: {
    form: policiesFormStore,
  },
};
